let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iAaum"), load("6vzdH"), load("5YJ6r"), load("c6MKV"), load("joJy8"), load("aHE9G"), load("gmwfN")]).then(() => parcelRequire('53kS0'));